module.exports = __webpack_public_path__ + "static/img/WXme.fa3711.cad0511.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/WXme.fa3711.jpg
// module id = vBYC
// module chunks = 2